const toTitleCase = (value: string) =>
    value
        .split(' ')
        .map((str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase())
        .join(' ');

export { toTitleCase };
